import { Expose } from 'class-transformer';

import { SnUser } from '@lib/api/entities';
import { SnModel } from '@lib/common/models';

export class SnIncidentMedia extends SnModel {
  @Expose()
  public id: string;

  @Expose()
  public createdTimestamp: string;

  @Expose()
  public updatedTimestamp: string;

  @Expose()
  public incident: string;

  @Expose()
  public url: string;

  @Expose()
  public description: string;

  @Expose()
  public type: string;

  @Expose()
  public user: SnUser[];

  constructor(data: any = {}) {
    super();
    this.fromJSON(data);
  }
}
